<template>

    <el-form-item
        :rules="{ required: isFieldRequired, validator: validateField, trigger: 'change' }"
        :label="field.label"
        :prop="fieldProp(field)"
        slot="reference"
    >

        <span slot="label">
            {{ field.label }}
            <span v-if="!_.isEmpty(field.content)" class="fin-relative fin-z-50 fin-ml-1"
                :class="isFrontend ? 'fin-hidden' : 'fin-hidden 2xl:fin-inline-flex'">
                <el-popover
                    placement="top-start"
                    :title="field.label"
                    width="200"
                    trigger="hover"
                    :content="field.content"
                    :disabled="_.isEmpty(field.content)"
                    popper-class="app-form-field-popover"
                    >
                    <i slot="reference" class="fas fa-circle-info fin-ml-2 fin-text-warning"></i>
                </el-popover>
            </span>
        </span>

        <div v-if="!_.isEmpty(field.content)" class="content fin-flex fin-w-full"
            :class="isFrontend ? '' : '2xl:fin-hidden'">
            {{ field.content }}
        </div>
    
        <el-input :type="_.get(field, 'options.type', 'text')" @focus="setCurrentField(field)" v-model="inputValue" :placeholder="field.placeholder" clearable>
            <div v-if="field.options.prepend" slot="prepend" v-html="field.options.prepend"></div>
            <div v-if="field.options.append" slot="append" v-html="field.options.append"></div>
            <div v-if="field.options.prefix" slot="prefix" v-html="field.options.prefix"></div>
            <div v-if="field.options.suffix" slot="suffix" v-html="field.options.suffix"></div>
        </el-input>
    </el-form-item>
</template>

<script>
import formMixin from "@tenant/app-form/mixins/formMixin"

export default {
    name: "InputField",

    mixins: [formMixin],

    props: {
        field: {
            required: true,
            type: [Object, Array],
        },
        fieldKey: {
            required: true,
            type: Number,
        },
        path: {
            required: true,
            type: [String, Number],
        },
        value: {
            required: false,
        },
        formStore: {
            required: false,
            type: String,
            default: "formStore"
        },
    },

    data() {
        return {
            inputValue: null,
        }
    },

    mounted() {
        this.$store.dispatch(`${this.formStore}/form/setPagePaths`, this.path)
    },

    computed: {
        isFieldRequired() {
            return this.field.isRequired
        },
    },

    methods: {
        validateField(rule, value, callback) {
            if (!this.inputValue && this.isFieldRequired) {
                callback(new Error(`${this.field.label} is Required`))
            } else if (this.field.minChars && _.size(this.inputValue) < this.field.minChars) {
                callback(new Error(`${this.field.label} is Required`))
            } else {
                callback()
            }
        },
    },

    watch: {
        inputValue: {
            handler(inputValue) {
                let path = String(this.path).split(".")
                this.setPathData(path, inputValue)
                this.checkRules(this.field, this.path)
            },
            immediate: true,
        },
        value: {
            handler(value) {
                this.inputValue = !_.isNull(value) && typeof value !== "undefined" ? String(value) : null
            },
            immediate: true,
        },
    },
}
</script>

<style lang="scss" scoped>
    .el-input :deep {
        .el-input__prefix, .el-input__suffix {
            @apply fin-min-w-[30px] fin-flex fin-items-center fin-justify-center fin-text-body-light
        }

        @apply fin-text-body
    }
</style>
